import { useEffect } from "react";
import Lenis from "lenis";

let lenisInstance = null;

/**
 * Singleton Lenis smooth-scroll. Mount once at App root.
 * Exposes a global `__lenis` for ScrollManager to use for anchor scrolls.
 */
export default function SmoothScroll() {
  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (mq.matches) return;

    lenisInstance = new Lenis({
      lerp: 0.14,
      duration: 0.8,
      smoothWheel: true,
      wheelMultiplier: 1.15,
      touchMultiplier: 1.4,
    });

    window.__lenis = lenisInstance;

    let rafId = 0;
    const raf = (time) => {
      lenisInstance && lenisInstance.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      lenisInstance && lenisInstance.destroy();
      lenisInstance = null;
      window.__lenis = null;
    };
  }, []);

  return null;
}
